import { ViewList } from "@mui/icons-material";
import {
  Menu,
  MenuItemLink,
  useResourceDefinitions,
  useSidebarState,
  useTranslate,
} from "react-admin";
import {
  ADMINROLES,
  ADMINS,
  BRANDS,
  CATEGORIES,
  COUPONS,
  COURSES,
  PERMISSIONS,
  PRODUCTS,
  PRODUCTS_V2,
  PURCHASES,
  SELLERS,
  SUPPLIERS,
  SUPPLIER_PURCHASES,
  VOUCHERS,
  BANNERS,
  PRODUCT_GROUPS,
  DOCUMENTS,
  QUOTES,
  OFFERTS,
  SUPPLIER_PERMISSIONS,
  DASHBOARD_CONSUMO,
  TEXTILES,
} from "../config/resources";
import { useAdmin } from "../hooks/admin";
import { TPermissionId } from "@/resources/permissions/data";
import { country } from "@/config/country";

export const SideMenu = (props: any) => {
  const { hasPermission, shouldShowApp } = useAdmin();
  const [open] = useSidebarState();
  const t = useTranslate();

  const resourcesDefinitions = useResourceDefinitions();
  const resources = Object.keys(resourcesDefinitions).map(
    (name) => resourcesDefinitions[name]
  );

  if (!shouldShowApp) return null;

  const rawMenu: { resource: string; permission?: TPermissionId }[] = [
    {
      resource: PURCHASES,
      permission: "purchase.list",
    },
    {
      resource: SUPPLIER_PURCHASES,
      permission: "purchase.list",
    },
    {
      resource: VOUCHERS,
      permission: "voucher.list",
    },
    {
      resource: PRODUCTS,
      permission: "product.list",
    },
    {
      resource: PRODUCTS_V2,
      permission: "product.list",
    },
    {
      resource: SELLERS,
      permission: "seller.list",
    },
    {
      resource: SUPPLIERS,
      permission: "supplier.list",
    },
    {
      resource: ADMINS,
      permission: "admin.list",
    },
    {
      resource: ADMINROLES,
      permission: "adminrole.list",
    },
    {
      resource: PERMISSIONS,
      permission: "permission.list",
    },
    {
      resource: SUPPLIER_PERMISSIONS,
      permission: "supplier-permission.list",
    },
    {
      resource: DASHBOARD_CONSUMO,
    },
    {
      resource: TEXTILES,
    },
  ];

  const resourcesAvailablesByCountry = rawMenu.filter(
    (item) => !country.hiddenResources?.includes(item.resource)
  );

  const permittedResources = resourcesAvailablesByCountry.filter(
    (item) => !item.permission || hasPermission(item.permission)
  );

  // After removing the corresponding <Resource> from App.tsx the entry in
  // rawMenu becomes a dangling reference; filter those out so the menu
  // doesn't crash on .name of undefined.
  const availableResources = permittedResources
    .map((item) => resources.find((r) => r.name === item.resource))
    .filter((r): r is NonNullable<typeof r> => Boolean(r));

  return (
    <Menu {...props} sx={{ mb: "120px" }}>
      {availableResources.map((resource) => (
        <MenuItemLink
          key={resource.name}
          to={`/${resource.name}`}
          primaryText={
            resource.options?.label ||
            (resource.name === COURSES
              ? "Educación"
              : t(`resources.${resource.name}.name`, { smart_count: 2 }))
          }
          leftIcon={resource.icon ? <resource.icon /> : <ViewList />}
          onClick={props.onMenuClick}
          sidebarIsOpen={open}
        />
      ))}
    </Menu>
  );
};
